import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    title: 'Kit Inicio Profesional',
    value: '12€',
    items: ['Bio lista', 'Identidad profesional', 'Checklist inicio']
  }, {
    title: 'Guiones WhatsApp',
    value: '12€',
    items: ['+12 guiones listos', 'Respuestas rápidas', 'Situaciones difíciles', 'Plantillas de derivaciones y pacientes difíciles']
  }, {
    title: 'Plan 7 Días',
    value: '12€',
    items: ['Tareas diarias', 'Checklist', 'Seguimiento avance']
  }];
  return <Section data-id="element-52">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-3 text-brand-primary" data-id="element-53">
        🎁 3 BONOS GRATIS
      </h2>
      <p className="font-body text-center text-brand-textMuted mb-6 text-sm" data-id="element-54">
        Valor 36€ · Incluidos sin coste
      </p>

      <div className="grid md:grid-cols-3 gap-4 max-w-5xl mx-auto" data-id="element-55">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-4 shadow-sm" data-id="element-56">
            <div className="flex items-start justify-between mb-3" data-id="element-57">
              <h3 className="font-heading text-base font-bold text-brand-primary flex-1" data-id="element-58">
                {bonus.title}
              </h3>
              <div className="text-right" data-id="element-59">
                <div className="text-brand-textMuted text-xs line-through" data-id="element-60">
                  {bonus.value}
                </div>
                <div className="text-green-600 font-body font-bold text-sm" data-id="element-61">
                  GRATIS
                </div>
              </div>
            </div>

            <ul className="space-y-1" data-id="element-62">
              {bonus.items.map((item, j) => <li key={j} className="flex items-start gap-2" data-id="element-63">
                  <span className="text-green-500 shrink-0 text-sm" data-id="element-64">✓</span>
                  <span className="font-body text-brand-text text-xs" data-id="element-65">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>)}
      </div>
    </Section>;
}